import styled from 'styled-components';
import { darkGreen, greyLight, greyText, white } from '../../../styles/Variables';
import { AiOutlineClose } from 'react-icons/ai';
import { WiRefresh } from 'react-icons/wi';
import { deviceMax } from '../../../styles/MediaQuery';

export const FiltersWrapper = styled.div`
    width: 100%;
    min-height: 80px;
    background-color: ${greyLight};

    @media ${deviceMax.tablet} {
        background-color: ${white};
    }
`;

export const ButtonsWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto auto;
    padding: 20px;
    column-gap: 20px;

    @media ${deviceMax.tablet} {
        grid-template-columns: 1fr;
    }
`;

export const ButtonWrapper = styled.div``;

export const FunctionButtonsWrapper = styled.div`
    position: relative;
    display: grid;
    grid-template-columns: auto auto;
    margin: 0 20px 0 15px;
`;

export const ChosenFiltersWrapper = styled.div`
    max-width: 80%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
`;

export const ChosenFilterButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    font-size: 0.875rem;
    line-height: 1em;
    padding: 12px;
    color: ${darkGreen};
    background-color: ${white};
    border: none;
    cursor: pointer;
    border-radius: 5px;
    margin: 0 5px 10px 5px;
    font-family: Arial, Helvetica, sans-serif;
`;

export const Close = styled(AiOutlineClose)`
    fill: ${darkGreen};
    font-size: 0.875rem;
    margin-left: 1rem;
`;

export const ClearButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 2.5rem;
    font-size: 0.875rem;
    padding: 7px 12px;
    color: ${white};
    background-color: ${greyText};
    border: none;
    cursor: pointer;
    border-radius: 5px;
    right: 0;
    position: absolute;
    font-family: Arial, Helvetica, sans-serif;
`;

export const Reset = styled(WiRefresh)`
    fill: ${white};
    font-size: 1.5rem;
    margin-left: 0.5rem;
`;
